const defaultColDef = {
  // sortable: true,
  // filter: true,
  // floatingFilter: true,
  resizable: true,
  // flex: 1,
};

export default defaultColDef;
